<mat-card class="slidecontent">
  <div class="pophead">    
    <div class="head">
     <h3>Form Fields map with System Fields</h3>
    <button mat-icon-button class="delRow" (click)="deleteSelectedFields()" *ngIf="ShowDeleteButton==true">
      <mat-icon>delete_outline</mat-icon>
    </button>
    </div>   

    <div class="">
      <button (click)="closeAiDetail(false)" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  
  
  <div class="bindFields">

    <div class="coreSelectionHolder">
      
      <div class="coreChange" *ngIf="!toggleChangeCore">
        <div class="selectedCore">
          <h3>{{name}}</h3>
          <p>{{email}}</p>
        </div>
  
        <div class="">
          <button mat-stroked-button color="primary" (click)="ChangeCore()">Change</button>
        </div>
      </div>

      <div class="forChange" *ngIf="toggleChangeCore">
        <div class="blockSelection">
          <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCCC($event)">
            <mat-radio-button value="Core" [checked]="checkedAttachCore">{{CoreShowName}}</mat-radio-button>
            <mat-radio-button value="Contact" [disabled]="true" [checked]="checkedAttachContact">{{ContactShowName}}</mat-radio-button>
            <mat-radio-button value="Company" [disabled]="true" [checked]="checkedAttachCompany">{{CompanyShowName}}</mat-radio-button>
          </mat-radio-group>
        </div>
        
      
        <div class="autoComplete" *ngIf="ShowAttchedToCore || ShowAttchedToContact || ShowAttchedToCompany" >
          <ng-container class="" *ngIf="ShowAttchedToCore">
            <mat-form-field appearance="outline" style="position: relative;">
              <mat-label>Search {{CoreShowName}}</mat-label>
              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                (input)="searchCore($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
              <mat-autocomplete #auto="matAutocomplete" class="autooooo" >
                <ng-container *ngFor="let core of attachedToCoreList">
                  <mat-option (click)="attchedToCoreSelected(core)" [ngClass]="{'createNew': core.name == 'Create New'}" 
                  [value]="core.name">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="userpic">
                      <img *ngIf="core.imageUrl!='' " src="{{core.imageUrl}}" alt="">
                      <span class="username" *ngIf="core.imageUrl==''" class="username">
                        {{core.shortName}}
                      </span>
                    </div>
                    <div class="info" >
                      <p> {{ core.name }}</p>
                      <p class="email">{{ core.email }}</p>
                    </div>
                  </span>
                </mat-option>
                </ng-container>
           
              </mat-autocomplete>
        
            </mat-form-field>
            <ul class="selectedlist" *ngFor="let core of attachedToSelectedCore">
              <li>
                <div class="userndetail">
                  <div class="userpic">
                    <img *ngIf="core.img!=''" src="{{core.img}}" alt="">
                    <span *ngIf="core.img==''" class="username">
                      {{core.shortName}}
                    </span>
                  </div>
                  <div class="details">
                    <h4>{{core.name}}</h4>
                    <p>{{core.email}}</p>
                  </div>
                  <div class="opt">
                    <button mat-icon-button>
                      <mat-icon (click)="attchedToRemoveCore(core)">cancel</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
    
          <ng-container class="" *ngIf="ShowAttchedToContact">
            <mat-form-field appearance="outline" style="position: relative;">
              <mat-label>Search {{ContactShowName}}</mat-label>
              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                (input)="searchContacts($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="attchedToContactSelected(contact)"
                  *ngFor="let contact of attachedToContactList" [value]="contact.name">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="userpic">
                      <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                      <span class="username" *ngIf="contact.imageUrl==''" class="username">
                        {{contact.shortName}}
                      </span>
                    </div>
                    <div class="info">
                      <p> {{ contact.name }}</p>
                      <p class="email">{{ contact.email }}</p>
                    </div>
                  </span>
                </mat-option>
              </mat-autocomplete>
        
            </mat-form-field>
            <ul class="selectedlist" *ngFor="let contact of attachedToSelectedContact">
              <li *ngIf="!contact.isDeleted">
                <div class="userndetail">
                  <div class="userpic">
                    <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
                    <span *ngIf="contact.img==''" class="username">
                      {{contact.shortName}}
                    </span>
                  </div>
                  <div class="details">
                    <h4>{{contact.name}}</h4>
                    <p>{{contact.email}}</p>
                  </div>
                  <div class="opt">
                    <button mat-icon-button>
                      <mat-icon (click)="attchedToRemoveContact(contact)">cancel</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
        
          <ng-container class="" *ngIf="ShowAttchedToCompany">
            <mat-form-field appearance="outline"  style="position: relative;">
              <mat-label>Search {{CompanyShowName}}</mat-label>
              <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                (input)="searchCompany($event.target.value)" [formControl]="stateCtrl" id="stateCtrlid">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="attchedToCompanySelected(company)"
                  *ngFor="let company of attachedToCompanyList" [value]="company.name">
                  <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                    <div class="userpic">
                      <img *ngIf="company.imageUrl!=''" src="{{company.imageUrl}}" alt="">
                      <span class="username" *ngIf="company.imageUrl==''" class="username">
                        {{company.shortName}}
                      </span>
                    </div>
                    <div class="info">
                      <p> {{ company.name }}</p>
                      <p class="email">{{ company.email }}</p>
                    </div>
                  </span>
                </mat-option>
              </mat-autocomplete>
        
            </mat-form-field>
            <ul class="selectedlist" *ngFor="let company of attachedToSelectedCompany">
              <li *ngIf="!company.isDeleted">
                <div class="userndetail">
                  <div class="userpic">
                    <img *ngIf="company.img!=''" src="{{company.img}}" alt="">
                    <span *ngIf="company.img==''" class="username">
                      {{company.shortName}}
                    </span>
                  </div>
                  <div class="details">
                    <h4>{{company.name}}</h4>
                    <p>{{company.email}}</p>
                  </div>
                  <div class="opt">
                    <button mat-icon-button>
                      <mat-icon (click)="attchedToRemoveCompany(company)">cancel</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
      
    </div>

    
    <div class="table" >
      <!-- <form  [formGroup]="formDialog"> -->
      <table cellspacing="0" cellpadding="0" >
        <tr>
          <!-- <th><input type="checkbox"></th> -->
          <th width="3%"></th>
          <th width="22%">Form Feilds</th>
          <th width="8%"></th>
          <th width="22%">System Feilds</th>
          <th width="6%" class="text-center">AI</th>
          <th width="47%">Value</th>
        </tr>
        <tr *ngFor="let item of ExtractDocument;let i = index">
          <td>
            <mat-checkbox color="primary" (change)="getCheckboxValues($event, item)">
            </mat-checkbox>
          </td>
          <td>{{item.key}}</td>
          <td class="aiBtn">     
             <button *ngIf="item.fieldName==''" mat-stroked-button class="aiBtn" (click)="AutoFilled(item)">
               <mat-icon>arrow_right_alt</mat-icon>
             </button>
          </td>
          <td>
            <mat-form-field class="width" [ngStyle]="{'color': item.colorCode }">
              <input matInput placeholder="Choose fields"
              (input)="searchFields($event.target.value,item)"
              [matAutocomplete]="auto"             
              [(ngModel)]="item.fieldName"/>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="fieldValueSelected(pro,item)" *ngFor="let pro of fieldListFiltered"
                  [value]="pro.fieldName">
                  <span>{{ pro.fieldName }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>           
          </td>
          <td class="aiBtn">            
            <button *ngIf="item.colorCode=='#cc570e' || item.colorCode==''" mat-stroked-button class="aiBtn" 
            (click)="openAI(item,extract)">AI</button>
          </td>
          <td>
            <mat-form-field>
              <input matInput [(ngModel)]="item.value" (input)="ItemValue($event.target.value,item)"/>
            </mat-form-field>            
          </td>
        </tr>         

      </table>
      <!-- </form> -->

    </div>

  </div>

  <div class="bottomActions" *ngIf="ExtractDocument.length>0">
    <button mat-flat-button color="primary" [disabled]="CreateField" (click)="createFields()">Map Fields</button>
  
    <button mat-flat-button color="primary" [disabled]="Finish" (click)="finishFields()">Finish</button>
  </div>
 

</mat-card>



<ng-template #extract>
  <h2 mat-dialog-title>
    AI Field Mapping
    <button mat-icon-button (click)="closeAI()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content class="mat-typography">

    <div class="filedBlock">
      <h3> Synonym Fields</h3>
      <div class="" *ngIf="synonymFieldsAI.length>0">
        <div class="list" *ngFor="let item of synonymFieldsAI;let i = index" >
          <div class="listblock" (click)="fieldValueSelectedAI(item)">{{item.fieldName}}</div>
        </div>
      </div>
      <div *ngIf="synonymFieldsAI.length==0">
        <p class="notFound"> No Record Found</p>
      </div>
    </div>

    <div class="filedBlock">
      <h3>System Fields</h3>
      <div class="" *ngIf="systemFieldsAI.length>0">
        <div class="list" *ngFor="let item of systemFieldsAI;let i = index" >
          <div class="listblock" (click)="fieldValueSelectedAI(item)">{{item.fieldName}}</div>
        </div>
      </div>
      <div *ngIf="systemFieldsAI.length==0">
        <p class="notFound" > No Record Found</p>
      </div>
    </div>

    
  
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAI()">Cancel</button>
    <!-- <div class="">
    <button mat-stroked-button color="primary" [disabled]="aiMapFields" (click)="MapFieldsAI()">Map Fields</button>   
    </div> -->

  </mat-dialog-actions>
</ng-template>


<app-addnew *ngIf="showAddCore" (closeAdd)="getClose($event)" [name]="searchName" 
 [isShared]="isShare"
 [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddCore}"
 (selectedCoreIdForAI)=getselectedTransactionId($event) >
</app-addnew>


<app-loader></app-loader>